export const isCallback = <Parameters extends unknown[], Return>(
  maybeFunction: unknown | ((...args: Parameters) => Return),
): maybeFunction is (...args: Parameters) => Return => typeof maybeFunction === "function";
